import React from "react";

export default function CategoryComponent({ name, func }) {
  return (
    <div className="flex justify-between">
      <div className="event_cat">{name}</div>
      <div className="event_cat_2 cursor-pointer" onClick={() => func()}>
        View all
      </div>
    </div>
  );
}
